import { 
  SaveLoginData, 
  GetToken, 
  GetAuth,
  GetUser, 
  removeLoginData, 
  GetAgent
} from '@/utils/cookies';
import { Message } from "element-ui"
import router from '@/router'
let isOuting = false
let outTimer
export default {
  state: {
    token: GetToken(),
    auth: GetAuth(),
    user: GetUser(),
    agent: GetAgent()
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    auth: state => state.auth,
  },
  mutations: {
    setLoginData(state, data = {}){
      let { token, auth, user, agent } = data
      state.token = token
      state.auth = auth
      state.user = user
      state.agent = agent
      SaveLoginData(data);
    },
    logout(state, isForceOut){
      if(isOuting)
        return
      isOuting = true;
      state.token = ''
      state.auth = []
      state.user = {}
      state.agent = {}
      removeLoginData();
      Message({
        type: 'warning',
        message: isForceOut
        ? '登录信息已过期，请重新登录'
        : '您已成功登出'
      })
      router.push({
        name: 'Login',
        query: {
          redirect: router.currentRoute.path
        }
      }).finally(() => {
        if(outTimer)
          clearTimeout(outTimer)
        outTimer = setTimeout(
          () => isOuting = false, 
          1000
        )
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/user.js